











































import { Component, Mixins, Prop } from "vue-property-decorator";

@Component({
})
export default class TexturePattern extends Mixins() {
  @Prop()
  color: string;

  @Prop()
  prefix: string;

  getTextureName(textureId: number) {
    return this.prefix + textureId;
  }

  get textureStyle() {
    return {
      stroke: this.color,
      fill: this.color,
    };
  }
}
